import { render, staticRenderFns } from "./AcceptVoteModal.vue?vue&type=template&id=56645a1f&scoped=true&"
import script from "./AcceptVoteModal.vue?vue&type=script&lang=js&"
export * from "./AcceptVoteModal.vue?vue&type=script&lang=js&"
import style0 from "./AcceptVoteModal.vue?vue&type=style&index=0&id=56645a1f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56645a1f",
  null
  
)

export default component.exports